import script from "./FileElement.vue?vue&type=script&lang=js"
export * from "./FileElement.vue?vue&type=script&lang=js"

import "./FileElement.vue?vue&type=style&index=0&id=dc09ef58&lang=scss"

const __exports__ = script;

export default __exports__